import { collabStateManager } from '@databases/collab-state-manager';
import { isAIFCStagingAreaView } from '@databases/database-state';
import usePanel from '@databases/panel/usePanel';
import usePanelState from '@databases/panel/usePanelState';
import { useEffect } from 'react';

import { getFrameApi } from '@canvas/frame-api/host-api/host-frame-context';

/**
 * This particular hook being so high up in the application causes every child to re-render
 * when the panel state changes. This should be moved.
 *
 * @deprecated This will become an event listener on panel state changes.
 */
export const useSetupPanel = ({ contentId }: { contentId: string }) => {
  const { showPanel, hidePanel } = usePanel();
  const { isPanelVisible } = usePanelState();

  const collabManager = collabStateManager.getCollabManager(contentId);
  const wasCreatedThisSession = collabManager?.wasCreatedThisSession;
  const isInAIFCStagingAreaView = isAIFCStagingAreaView();
  const frameApiHref = getFrameApi().href;
  const frameApiHrefUrl = new URL(frameApiHref);
  const hasAiCreateFlowQueryParam =
    frameApiHrefUrl.searchParams.get('flow') === 'aiCreate';

  useEffect(() => {
    if (hasAiCreateFlowQueryParam) {
      return; // Do not render setup panel if created through AI flow
    }

    if (isInAIFCStagingAreaView) {
      if (isPanelVisible('DatabaseSetupPanel')) {
        hidePanel();
      }
      return; // Do not render setup panel in rovo AIFC staging area
    }

    // When navigating between databases in content tree we hide the panel unless it was created in the current session
    if (isPanelVisible('DatabaseSetupPanel')) {
      hidePanel();
    }

    if (wasCreatedThisSession) {
      showPanel('DatabaseSetupPanel');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
